import React from 'react';
import { anchorPathLabel, moduleBlockCount, type SpecModule } from '../../shared/spec-modules';

/* ─── Read-only preview of one module ───
   Deliberately NOT an editor: chunk headings carry the anchor path the
   capture recorded, and each block is shown at its captured level. Phase 5
   is what turns this into something you can place. */
export function ModulePreview({ module }: { module: SpecModule }) {
  return (
    <div style={{ display: 'grid', gap: 'var(--space-4)' }}>
      <div style={{ display: 'grid', gap: 'var(--space-1)' }}>
        <div
          style={{
            fontSize: 'calc(var(--font-size-base) * 15 / 13)',
            fontWeight: 700,
            color: 'var(--tx)',
          }}
        >
          {module.name}
        </div>
        {module.description && (
          <div style={{ fontSize: 'var(--font-size-base)', color: 'var(--tm)' }}>
            {module.description}
          </div>
        )}
        <div style={{ fontSize: 'calc(var(--font-size-base) * 12 / 13)', color: 'var(--tm)' }}>
          Version {module.version} · {moduleBlockCount(module)} block
          {moduleBlockCount(module) === 1 ? '' : 's'} in {(module.chunks || []).length} chunk
          {(module.chunks || []).length === 1 ? '' : 's'}
          {module.sourceCsi ? ` · captured from ${module.sourceCsi}` : ''}
        </div>
      </div>

      {(module.chunks || []).map((chunk, i) => (
        <section key={i} style={{ display: 'grid', gap: 'var(--space-2)' }}>
          <header
            style={{
              fontSize: 'var(--font-size-sm)',
              fontWeight: 700,
              letterSpacing: '.04em',
              textTransform: 'uppercase',
              color: 'var(--tm)',
              borderBottom: '1px solid var(--bd)',
              paddingBottom: 'var(--space-1)',
            }}
          >
            {anchorPathLabel(chunk.anchor)}
          </header>
          {(chunk.blocks || []).map((b) => (
            <p
              key={b.id}
              style={{
                margin: 0,
                fontSize: 'var(--font-size-base)',
                lineHeight: 1.5,
                color: 'var(--tx)',
                paddingLeft: `calc(var(--space-4) * ${Math.max(0, Math.min(8, (b.level || 1) - 1))})`,
                fontWeight: (b.level || 1) === 1 || b.bold ? 700 : 400,
                fontStyle: b.italic ? 'italic' : undefined,
                textDecoration: b.underline ? 'underline' : undefined,
              }}
            >
              {b.blockType === 'table'
                ? `[Table — ${b.tableData?.rows ?? 0} rows]`
                : b.blockType === 'image'
                  ? '[Image]'
                  : b.text || ' '}
            </p>
          ))}
        </section>
      ))}
    </div>
  );
}

export default ModulePreview;
